'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhotoSizeSelectSmall = function MdPhotoSizeSelectSmall(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 5v3.4h-3.2v-3.4h3.2z m6.8 0v3.4h-3.4v-3.4h3.4z m-13.4 13.4v3.2h-3.4v-3.2h3.4z m0-13.4v3.4h-3.4q0-1.3 1.1-2.3t2.3-1.1z m26.6 26.6v3.4h-3.2v-3.4h3.2z m0-26.6v3.4h-3.2v-3.4h3.2z m-6.6 26.6v3.4h-3.4v-3.4h3.4z m-20-20v3.4h-3.4v-3.4h3.4z m0 23.4q-1.3 0-2.3-1t-1.1-2.4v-6.6h16.8v10h-13.4z m30-30q1.3 0 2.3 1.1t1.1 2.3h-3.4v-3.4z m3.4 6.6v3.4h-3.4v-3.4h3.4z m-13.4-6.6v3.4h-3.4v-3.4h3.4z m13.4 26.6q0 1.3-1.1 2.3t-2.3 1.1v-3.4h3.4z m0-13.2v3.2h-3.4v-3.2h3.4z m0 6.6v3.4h-3.4v-3.4h3.4z' })
        )
    );
};

exports.default = MdPhotoSizeSelectSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/photo-size-select-small.js
// module id = 3176
// module chunks = 0